import { ShopperInfoFieldEnum, ShopperInfoRequirementType, SupportedLanguageEnum } from "utils/enums";
import { StringResources } from "utils/language/languageResource";

export interface CreateTokenizeLinkModalProps {
    title?: string;
    actionButtonText?: string;
    data: {
        isUpdate: boolean;
        isCopy: boolean;
        tokenizeByLinkId?: number | undefined;
        existingData?: UpdateTokenizeLinkModalProps;
    };
}

export interface UpdateTokenizeLinkModalProps {
    ecomSolutionId: number;
    themeId?: number;
    contractId: number;
    exactSalesCount?: number;
    tokenizeByLinkDescription?: string;
    languageType: SupportedLanguageEnum;
    validTo?: string;
    recurringProcessingModel: string;
    shopperInfoData: Array<UpdateShopperInfoDataTokenizeLinkModalProps>;
}

export interface UpdateShopperInfoDataTokenizeLinkModalProps {
    shopperInfoRequirementType: ShopperInfoRequirementType;
    field: ShopperInfoFieldEnum;
    value?: string;
}

export interface ICreateTokenizeByLinkRequestForm {
    ecomSolutionId?: number;
    contractId?: number;
    recurringProcessingModel?: number;
    themeId?: number;
    language: SupportedLanguageEnum;
    hasExpirationDate?: boolean;
    tokenizeByLinkDescription?: string;
    linkReuse?: boolean;
    dateTo?: Date;
    shopperInfoData: Array<ITokenizeLinkShopperInfo>;
}

export interface IConfirmationOptions {
    description: string;
    hasValue: boolean;
}

export interface IEcomResponseData {
    dbaName: string;
    contractNumber: string;
    contractId: number;
    currencyId: string;
    tid: string;
    ecomSolutionId: number;
}

export interface ITokenizeLinkThemeResponseData {
    themeId: number;
    themeName: string;
    themeDescription?: string;
}

export interface ITokenizeLinkShopperInfo {
    id?: number | undefined;
    label: string;
    shopperInfoRequirementType: ShopperInfoRequirementType;
    field: ShopperInfoFieldEnum;
    value?: string;
}

export const shopperInfoDataInitialValues: Array<ITokenizeLinkShopperInfo> = [
    {
        label: StringResources.modal.createTokenizeLink.ssn,
        field: ShopperInfoFieldEnum.Ssn,
        shopperInfoRequirementType: ShopperInfoRequirementType.Hidden,
    },
    {
        label: StringResources.modal.createTokenizeLink.fullName,
        field: ShopperInfoFieldEnum.FullName,
        shopperInfoRequirementType: ShopperInfoRequirementType.Hidden,
    },
    {
        label: StringResources.modal.createTokenizeLink.address,
        field: ShopperInfoFieldEnum.Address,
        shopperInfoRequirementType: ShopperInfoRequirementType.Hidden,
    },
    {
        label: StringResources.modal.createTokenizeLink.postCode,
        field: ShopperInfoFieldEnum.PostCode,
        shopperInfoRequirementType: ShopperInfoRequirementType.Hidden,
    },
    {
        label: StringResources.modal.createTokenizeLink.city,
        field: ShopperInfoFieldEnum.City,
        shopperInfoRequirementType: ShopperInfoRequirementType.Hidden,
    },
    {
        label: StringResources.modal.createTokenizeLink.country,
        field: ShopperInfoFieldEnum.Country,
        shopperInfoRequirementType: ShopperInfoRequirementType.Hidden,
    },
    {
        label: StringResources.modal.createTokenizeLink.telephone,
        field: ShopperInfoFieldEnum.Telephone,
        shopperInfoRequirementType: ShopperInfoRequirementType.Hidden,
    },
    {
        label: StringResources.modal.createTokenizeLink.emailAddress,
        field: ShopperInfoFieldEnum.EmailAddress,
        shopperInfoRequirementType: ShopperInfoRequirementType.Hidden,
    },
    {
        label: StringResources.modal.createTokenizeLink.comments,
        field: ShopperInfoFieldEnum.Comments,
        shopperInfoRequirementType: ShopperInfoRequirementType.Hidden,
    },
];
